function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.167 4.5L2.825 19.513A1 1 0 003.7 21h17.517a1 1 0 00.853-1.521L12.894 4.464a1 1 0 00-1.727.035z",
  fill: "#F8C782",
  opacity: 0.3
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#FFA273",
  x: 11,
  y: 9,
  width: 2,
  height: 7,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#FFA273",
  x: 11,
  y: 17,
  width: 2,
  height: 2,
  rx: 1
}));

function SvgWarningTriangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjRweCIgaGVpZ2h0PSIyNHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUzLjIgKDcyNjQzKSAtIGh0dHBzOi8vc2tldGNoYXBwLmNvbSAtLT4KICAgIDx0aXRsZT5TdG9ja2hvbG0taWNvbnMgLyBDb2RlIC8gV2FybmluZy0yPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGcgaWQ9IlN0b2NraG9sbS1pY29ucy0vLUNvZGUtLy1XYXJuaW5nLTIiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxyZWN0IGlkPSJib3VuZCIgeD0iMCIgeT0iMCIgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0Ij48L3JlY3Q+CiAgICAgICAgPHBhdGggZD0iTTExLjE2Njk4OTksNC40OTk0MTgxOCBMMi44MjUzNTcxOCwxOS41MTQzNTcxIEMyLjU1NzE0NCwxOS45OTcxNDA4IDIuNzMxMDg3OCwyMC42MDU5NDQxIDMuMjEzODcxNTMsMjAuODc0MTU3MyBDMy4zNjI0Mjk1MywyMC45NTY2ODk1IDMuNTI5NTcwMjEsMjEgMy42OTk1MTQ0NiwyMSBMMjEuMjE2OTQzMiwyMSBDMjEuNzY5MjI3OSwyMSAyMi4yMTY5NDMyLDIwLjU1MjI4NDcgMjIuMjE2OTQzMiwyMCBDMjIuMjE2OTQzMiwxOS44MTU5OTUyIDIyLjE2NjE3NDMsMTkuNjM1NTU3OSAyMi4wNzAyMjUsMTkuNDc4NTUgTDEyLjg5NDQyOSw0LjQ2MzYxMTEgQzEyLjYwNjQ0MDEsMy45OTIzNTY1NiAxMS45OTA5NTE3LDMuODQzNzkwMzkgMTEuNTE5Njk3Miw0LjEzMTc3OTI4IEMxMS4zNzIzNTk0LDQuMjIxODE5MDIgMTEuMjUwODQ2OCw0LjM0ODQ3NTgzIDExLjE2Njk4OTksNC40OTk0MTgxOCBaIiBpZD0iUGF0aC0xMTciIGZpbGw9IiNGOEM3ODIiIG9wYWNpdHk9IjAuMyI+PC9wYXRoPgogICAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGUtOSIgZmlsbD0iI0ZGQTI3MyIgeD0iMTEiIHk9IjkiIHdpZHRoPSIyIiBoZWlnaHQ9IjciIHJ4PSIxIj48L3JlY3Q+CiAgICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZS05LUNvcHkiIGZpbGw9IiNGRkEyNzMiIHg9IjExIiB5PSIxNyIgd2lkdGg9IjIiIGhlaWdodD0iMiIgcng9IjEiPjwvcmVjdD4KICAgIDwvZz4KPC9zdmc+";
export { SvgWarningTriangle as ReactComponent };